import { render, staticRenderFns } from "./ImageRightsNotice.vue?vue&type=template&id=564645de&"
import script from "./ImageRightsNotice.vue?vue&type=script&lang=js&"
export * from "./ImageRightsNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports